import Text from 'components/commons/Text';
import InputField from 'components/input/InputField';
import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import IconButton from 'controls/IconButton';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button, Row, useModelStateContext } from 'saladsoft-primitive';
import { AdminBusinessRequestDto, AdminBusinessDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import styled from 'styled-components';

const BusinessForm = ({ businessInfo }: { businessInfo?: AdminBusinessDto }) => {
  const { setState, setMultipleState, stateModel, unmountModel } =
    useModelStateContext<AdminBusinessRequestDto>();
  const { uiStore } = useStoreWrapper();

  const handleClickCreate = () => {
    if (businessInfo?.id) {
      ServiceHelper?.adminBusinessService
        ?.updateBusiness(businessInfo?.id, stateModel as AdminBusinessRequestDto)
        .then(async (res) => {
          if (res.status === 200) {
            closeModal('사업자 수정이 완료되었습니다.');
          } else {
            toast.error('사업자 수정에 실패하였습니다.');
          }
        });
    } else {
      if (stateModel) {
        const newState = { ...stateModel, isActive: true };
        ServiceHelper.adminBusinessService?.createBusiness(newState).then((res) => {
          if (res.status === 200) {
            closeModal('사업자 추가가 완료되었습니다.');
          } else {
            toast.error('사업자 추가에 실패하였습니다.');
          }
        });
      }
    }
  };

  const onClickDelete = () => {
    if (businessInfo?.id) {
      uiStore?.confirm.show({
        title: '사업자정보 삭제 확인',
        message: '사업자정보를 삭제하시겠습니까?',
        onConfirmed: () => {
          ServiceHelper?.adminBusinessService
            ?.deleteBusiness(businessInfo?.id as number)
            .then((res) => {
              closeModal('사업자 삭제가 완료되었습니다.');
            });
        },
      });
    }
  };

  const closeModal = (title: string) => {
    toast.success(title);
    uiStore?.modal.confirm();
  };

  useEffect(() => {
    if (businessInfo) {
      setMultipleState(businessInfo);
    }
  }, [businessInfo]);

  useEffect(() => {
    return () => {
      unmountModel();
    };
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <InnerSection>
        <InnerGroup>
          <div>
            <Text type="H3">사업자정보</Text>
            <Text type="H4">사업자정보를를 입력 해주세요.</Text>
          </div>
          <Row gap={10} flexDirection="column" width="100%" alignItems="space-between">
            <div style={{ width: '100%' }}>
              <InputField
                label="사업자명"
                defaultValue={businessInfo?.name}
                onChange={(value) => setState('name', value)}
              />
            </div>
            <div style={{ width: '100%' }}>
              <InputField
                label="대표자명"
                defaultValue={businessInfo?.ownerName}
                onChange={(value) => setState('ownerName', value)}
              />
            </div>
            <div style={{ width: '100%' }}>
              <InputField
                label="사업자등록번호"
                defaultValue={businessInfo?.registrationNumber}
                onChange={(value) => setState('registrationNumber', value)}
              />
            </div>
            <div style={{ width: '100%' }}>
              <InputField
                label="통신판매업 등록번호"
                defaultValue={businessInfo?.commerceRegistrationNumber}
                onChange={(value) => setState('commerceRegistrationNumber', value)}
              />
            </div>
            <div style={{ width: '100%' }}>
              <InputField
                label="주소"
                defaultValue={businessInfo?.address}
                onChange={(value) => setState('address', value)}
              />
            </div>
            <div style={{ width: '100%' }}>
              <InputField
                label="전화번호"
                defaultValue={businessInfo?.phoneNumber}
                onChange={(value) => setState('phoneNumber', value)}
              />
            </div>
          </Row>
        </InnerGroup>
      </InnerSection>

      <InnerSection>
        <InnerGroup>
          <div>
            <Text type="H3">토스 결제정보(국내/해외겸용)</Text>
            <div style={{ fontSize: 12, color: '#ff0000' }}>
              국내/회외결제 겸용인 경우, "국내 키에만 적용 하여야 합니다."
            </div>
            <WarningText>입력된 토스 Client Id로 결제가 진행됩니다.</WarningText>
          </div>
          <div>
            <div>
              <Text type="H3">국내/회외겸용 토스 Secret Key</Text>
            </div>
            <div>
              <InputField
                defaultValue={businessInfo?.tossSecretKey}
                onChange={(value) => setState('tossSecretKey', value)}
              />
            </div>

            <div style={{ marginTop: 20 }}>
              <Text type="H3">국내/회외겸용 토스 Client Id</Text>
            </div>
            <div>
              <InputField
                defaultValue={businessInfo?.tossClientKey}
                onChange={(value) => setState('tossClientKey', value)}
              />
            </div>
          </div>
        </InnerGroup>
      </InnerSection>
      <InnerSection>
        <InnerGroup>
          <div>
            <Text type="H3">토스 결제정보(해외전용)</Text>
            <WarningText>입력된 토스 Client Id로 결제가 진행됩니다.</WarningText>
          </div>
          <div>
            <div>
              <Text type="H3">해외전용 토스 Secret Key</Text>
            </div>
            <div>
              <InputField
                defaultValue={businessInfo?.tossSecretKeyOversea}
                onChange={(value) => setState('tossSecretKeyOversea', value)}
              />
            </div>

            <div style={{ marginTop: 20 }}>
              <Text type="H3">해외전용 토스 Client Id</Text>
            </div>
            <div>
              <InputField
                defaultValue={businessInfo?.tossClientKeyOversea}
                onChange={(value) => setState('tossClientKeyOversea', value)}
              />
            </div>
          </div>
        </InnerGroup>
      </InnerSection>
      <Row justifyContent="space-between" gap={10}>
        <Row gap={10}>
          <Button
            type="outlined"
            style={{ marginTop: 20 }}
            onClick={async () => {
              uiStore?.modal.close();
            }}
          >
            취소
          </Button>
          <Button
            style={{ marginTop: 20 }}
            onClick={async () => {
              if (stateModel) {
                handleClickCreate();
              }
            }}
          >
            {businessInfo?.id ? '사업자 수정' : '사업자 추가'}
          </Button>
        </Row>
        <>
          {businessInfo?.id && (
            <IconButton
              type="delete"
              style={{ marginTop: 20 }}
              onClick={async () => {
                onClickDelete();
              }}
            />
          )}
        </>
      </Row>
    </div>
  );
};

const WarningText = styled.div`
  color: #ff0000;
  font-size: 12px;
  margin-top: 5px;
`;

export default BusinessForm;
